/** «Рассылки» → «Страница брони» — ровно то, что отдаёт `GET /api/deals/links`. */
import { apiFetch, query } from "@/lib/api";

export type LinkChannel = "max" | "telegram" | "whatsapp";
export type LinkGroup = "day" | "week" | "month";

/** Счёт строки: ссылка считается в каждом поле один раз, `opens` — сумма открытий. */
export type LinkCounts = {
  /** Ссылок выдано (сделок). */
  issued: number;
  /** Открыли страницу хотя бы раз. */
  opened: number;
  opens: number;
  /** Перешли со страницы в мессенджер. */
  click_max: number;
  click_telegram: number;
  click_whatsapp: number;
  /** Запустили бота с хэшем брони — «подписались». */
  bot_max: number;
  bot_telegram: number;
  /** Живая push-подписка; `push_denied` — браузер отказал. */
  push: number;
  push_denied: number;
  /** Живой адрес почты. */
  email: number;
  /** Хоть одна подписка: бот MAX, бот Telegram, push или почта. */
  any: number;
};

export type LinkRow = LinkCounts & { day: string; to: string };

export type LinkItem = {
  id: number;
  deal_id: number;
  /** Повод выдачи: `manual` — руками, иначе вид рассылки. */
  source: string;
  url: string;
  /** Когда выдана, MSK. */
  issued: string;
  opens: number;
  open_first: string | null;
  open_last: string | null;
  clicks: Record<LinkChannel, number>;
  bot_max: number;
  bot_telegram: number;
  push: number;
  push_denied: number;
  email: number;
};

export type DealLinks = {
  from: string;
  to: string;
  group: LinkGroup;
  total: LinkCounts;
  rows: LinkRow[];
  sources: Record<string, number>;
  /** Ссылки периода, свежие сверху. */
  links: LinkItem[];
};

export function loadDealLinks(from: string, to: string, group: LinkGroup): Promise<DealLinks> {
  return apiFetch<DealLinks>(`/api/deals/links${query({ from, to, group })}`);
}
